export type RefreshHandler = () => Promise<string | null>;

let _handler: RefreshHandler | null = null;
let _inFlight: Promise<string | null> | null = null;

export function setRefreshHandler(handler: RefreshHandler | null): void {
  _handler = handler;
}

export function hasRefreshHandler(): boolean {
  return _handler !== null;
}

export function triggerRefresh(): Promise<string | null> {
  if (_inFlight) return _inFlight;
  if (!_handler) return Promise.resolve(null);
  const handler = _handler;
  _inFlight = (async () => {
    try {
      return await handler();
    } catch {
      return null;
    } finally {
      _inFlight = null;
    }
  })();
  return _inFlight;
}
